module.exports = __webpack_public_path__ + "static/img/Rtu2@2x.572f668b.png";